export default function authHeader() {
  // const jwtToken = localStorage.getItem("jwt");
  // console.log("jwt token is ",localStorage.getItem("jwt"))
  if (localStorage.getItem("jwt")) {
    return {
      // "Content-type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("jwt"),
    };
  } else {    
    return {
      "Content-type": "application/json"
    };
  }
}
